export type GrantableUserPayload = {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
};

export type GrantedUsersFetchedPayload = GrantableUserPayload[];

export type GrantedUsersFetchedAction = {
	type: 'GRANTED_USERS_FETCHED';
	payload: GrantedUsersFetchedPayload;
	accountId: number;
	ids: readonly number[];
};

export default (
	payload: GrantedUsersFetchedPayload,
	accountId: number,
	ids: readonly number[],
): GrantedUsersFetchedAction => ({
	type: 'GRANTED_USERS_FETCHED',
	payload,
	accountId,
	ids,
});
